/*
@function calculatePriceScore
@param {Object} listing
@param {Number} filterValue
*/
function calculatePriceScore(listing, filterValue) {
    var percent = (Math.round(listing.price / filterValue * 1000) / 10 - 100).toFixed(1);
    var weight = 1;
    var value = 0;
    var threshold = 4;

    if(0 >= percent && percent >= -5) {
        value = 10;
    } else if(-5 > percent && percent >= -7.5) {
        value = 9;
    } else if(-7.5 > percent && percent >= -10) {
        value = 8;
    } else if(-10 > percent && percent >= -12.5) {
        value = 7;
    } else if(-12.5 > percent && percent >= -15) {
        value = 6;
    } else if(-15 > percent && percent >= -17.5) {
        value = 5;
    } else if(-17.5 > percent && percent >= -35) {
        value = 4;
    }

    // All Others
    else {
        value = -10;
    }

    return {
        weight: weight,
        value: value,
        score: value * weight,
        metThreshold: (value * weight) >= threshold,
        metWhyWhyNotThreshold: (value * weight) >= threshold
    };
}

module.exports = calculatePriceScore;
